import React, { ReactNode } from "react";
import { IconButton, styled, Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

//region [[ Styles ]]
const ClinicDialogView = styled(Dialog)({
  zIndex: 1000,
  "& .MuiDialog-paper": { padding: "28px 40px" },
  "& .MuiDialogContent-root": { padding: "2px 0" },
  "& .MuiDialogActions-root": {
    padding: "14px 0 0 0",
    justifyContent: "space-between",
  },
});

const CloseButton = styled(IconButton)({
  position: "absolute",
  top: 20,
  right: 20,
  background: "white",
  zIndex: 1001,
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicDialogProps {
  onClose: () => void;
  closeButton: boolean;
  open: boolean;
  children: ReactNode | ReactNode[];
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicDialog = ({
  closeButton,
  onClose,
  open,
  maxWidth,
  ...props
}: ClinicDialogProps) => {
  return (
    <ClinicDialogView open={open} maxWidth={maxWidth} onClose={() => onClose()}>
      {closeButton && (
        <CloseButton onClick={() => onClose()}>
          <CloseIcon />
        </CloseButton>
      )}
      {props.children}
    </ClinicDialogView>
  );
};
